import { Component, Input } from '@angular/core';
import { EducatorSpecialProgramResultDto } from '../services/api.service';

@Component({
  selector: 'cert-special-program-badge',
  templateUrl: './special-program-badge.component.html',
  styles: `
    .badge {
      font-size: 1rem;
    }
  `,
  standalone: false,
})
export class SpecialProgramBadgeComponent {
  @Input() specialPrograms!: EducatorSpecialProgramResultDto[];
}
